import React from 'react';
import InfoPanel from '../../../common/infoPanel';
import { Outlet } from 'react-router-dom';
const ProfilerLandingPage = () => {
  return (
    <div className="flex h-screen bg-white overflow-y-auto">
      <InfoPanel />
      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 p-8">
        <Outlet />
      </div>
    </div>
  );
};

export default ProfilerLandingPage;